(() => {
  const ORACLE_HOLD_DURATION_MS = 800;

  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const oracleEntry = document.querySelector('[data-oracle-hold-entry]');
    if (oracleEntry && oracleEntry.dataset.oracleHoldReady !== 'true') {
      oracleEntry.dataset.oracleHoldReady = 'true';

      const movementTolerance = 14;
      let timer = null;
      let activePointerId = null;
      let startX = 0;
      let startY = 0;

      const stopTracking = () => {
        window.removeEventListener('pointermove', handlePointerMove);
        window.removeEventListener('pointerup', handlePointerEnd);
        window.removeEventListener('pointercancel', handlePointerEnd);
        window.removeEventListener('wheel', cancelHold);
        window.removeEventListener('scroll', cancelHold);
      };

      const cancelHold = () => {
        if (timer !== null) window.clearTimeout(timer);
        timer = null;
        activePointerId = null;
        oracleEntry.classList.remove('is-holding');
        stopTracking();
      };

      const openOracle = () => {
        const url = oracleEntry.dataset.oracleUrl;
        cancelHold();
        if (!url) return;

        const opening = new CustomEvent('l1no:oracle-open', {
          bubbles: true,
          cancelable: true,
          detail: { url },
        });
        if (oracleEntry.dispatchEvent(opening)) window.location.assign(url);
      };

      function handlePointerMove(event) {
        if (event.pointerId !== activePointerId) return;
        const distanceX = event.clientX - startX;
        const distanceY = event.clientY - startY;
        if (Math.hypot(distanceX, distanceY) > movementTolerance) cancelHold();
      }

      function handlePointerEnd(event) {
        if (event.pointerId === activePointerId) cancelHold();
      }

      oracleEntry.addEventListener('pointerdown', (event) => {
        if (event.button !== 0 || event.isPrimary === false || activePointerId !== null) return;
        if (event.pointerType === 'mouse') event.preventDefault();

        activePointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        oracleEntry.classList.add('is-holding');
        window.addEventListener('pointermove', handlePointerMove, { passive: true });
        window.addEventListener('pointerup', handlePointerEnd, { passive: true });
        window.addEventListener('pointercancel', handlePointerEnd, { passive: true });
        window.addEventListener('wheel', cancelHold, { passive: true });
        window.addEventListener('scroll', cancelHold, { passive: true });
        timer = window.setTimeout(openOracle, ORACLE_HOLD_DURATION_MS);
      });

      oracleEntry.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        openOracle();
      });
      oracleEntry.addEventListener('contextmenu', (event) => event.preventDefault());
      oracleEntry.addEventListener('dragstart', (event) => event.preventDefault());
    }

    const navigation = document.querySelector('[data-portal-navigation]');
    if (!navigation) return;

    const list = navigation.querySelector('.portalList');
    const links = Array.from(navigation.querySelectorAll('[data-portal-id]'));
    const jumpLinks = Array.from(document.querySelectorAll('[data-portal-jump]'));
    if (!list || !links.length) return;

    const setActive = (id = '') => {
      list.dataset.activePortal = id;
      links.forEach((link) => {
        link.dataset.active = link.dataset.portalId === id ? 'true' : 'false';
      });
    };

    links.forEach((link) => {
      link.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') setActive(link.dataset.portalId);
      });
      link.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') setActive();
      });
      link.addEventListener('focus', () => setActive(link.dataset.portalId));
      link.addEventListener('blur', () => setActive());
    });

    jumpLinks.forEach((jumpLink) => {
      jumpLink.addEventListener('click', (event) => {
        event.preventDefault();
        const reduceMotion = typeof window.matchMedia === 'function'
          && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        navigation.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start',
        });

        if (window.history?.replaceState) {
          window.history.replaceState(null, '', '#portal-navigation');
        }

        links[0].focus({ preventScroll: true });
      });
    });
  });
})();
